import {
  collection,
  onSnapshot,
  query,
  QueryConstraint,
} from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { firestoreService } from "../../firebase-config";

export function useFirestoreListener<T>(
  path: string,
  options?: {
    constraints?: QueryConstraint[];
    enabled?: boolean;
    mapFn?: (doc: any) => T;
  }
) {
  const { constraints = [], enabled = true, mapFn } = options || {};

  const [data, setData] = useState<T[]>([]);
  const listenerRef = useRef<any>(null);

  const unsubscribe = () => {
    if (listenerRef.current) {
      listenerRef.current();
      listenerRef.current = null;
    }
  };

  useEffect(() => {
    if (!enabled) return;

    const colRef = collection(firestoreService, path);

    unsubscribe();

    listenerRef.current = onSnapshot(
      constraints.length ? query(colRef, ...constraints) : colRef,
      (snapshot) => {
        const list: T[] = snapshot.docs.map((doc) =>
          mapFn
            ? mapFn({ id: doc.id, ...doc.data() })
            : ({ id: doc.id, ...doc.data() } as T)
        );
        setData(list);
      },
      (err) => {
        console.error("Firestore listener error:", err);
      }
    );

    return unsubscribe;
  }, [path, enabled]);

  return { data, unsubscribe };
}
